import { useTranslation } from 'react-i18next';
import { Link, Text } from '@resideo/blueprint-react';
import React from 'react';
import { UserTerms } from './UserTerms';
import { createMessageHandler } from '../../../utils/createMessageHandler';

const PartnerLinks = ({ viewTermsUrl }) => {
  const { t } = useTranslation();
  const messageHandler = createMessageHandler();

  return (
    <UserTerms>
      <Text data-test-terms-conditions-label>{t('signUp.acceptTerms')}</Text>
      <Link
        data-test-terms-link
        href={!messageHandler.hasMessageHandler ? viewTermsUrl : '#'}
        target='_blank'
        onClick={e => {
          if (messageHandler.hasMessageHandler) {
            e.preventDefault();
            postMessage('openExternalUrl', viewTermsUrl);
          }
        }}>
        {t('signUp.viewTerms')}
      </Link>
    </UserTerms>
  );
};

export default PartnerLinks;
